// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"104":"9ba17f27","173":"abe35882","271":"8eab2d0a","387":"8eab2d0a","475":"b70e14ac","670":"8eab2d0a","917":"7f710d5d","974":"8eab2d0a"}[chunkId] + ".chunk.css";
};